export default __webpack_public_path__ + "static/media/curiousBadge.30382aa2.svg";